var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "468.000000pt",
    height: "436.000000pt",
    viewBox: "0 0 468.000000 436.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,436.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2183 3619 c-33 -10 -69 -46 -383 -394 -90 -99 -184 -202 -209 -230 -189 -204 -310 -347 -320 -378 -14 -42 -2 -100 28 -139 33 -41 80 -48 329 -48 l231 0 3 -434 3 -434 30 -43 c58 -83 64 -84 360 -84 298 0 314 4 370 83 l30 44 3 434 3 434 234 0 c264 0 299 7 334 64 44 72 31 142 -41 216 -19 19 -189 208 -378 419 -412 459 -429 477 -478 490 -44 13 -105 13 -149 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212 1221 c-164 -28 -206 -262 -64 -357 22 -15 55 -24 105 -29 39 -3 522 -5 1072 -3 922 3 1002 4 1031 20 133 73 135 276 4 353 -35 20 -46 20 -1070 21 -569 1 -1054 -1 -1078 -5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUpload);
export default __webpack_public_path__ + "static/media/new-upload.5e97c5f9.svg";
export { ForwardRef as ReactComponent };